var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6037 7.70711L39.4675 18.5708C40.1775 19.2809 40.1775 20.4321 39.4675 21.1421L28.6037 32.0059C28.2132 32.3964 27.58 32.3964 27.1895 32.0059L26.0324 30.8488C25.6419 30.4583 25.6419 29.8251 26.0324 29.4346L33.7923 21.6747L0.999999 21.6747C0.447714 21.6747 -1.24376e-06 21.227 -1.19548e-06 20.6747L-1.05242e-06 19.0383C-1.00414e-06 18.486 0.447714 18.0383 0.999999 18.0383L33.7923 18.0383L26.0324 10.2784C25.6419 9.88788 25.6419 9.25472 26.0324 8.86419L27.1895 7.70711C27.58 7.31659 28.2132 7.31658 28.6037 7.70711Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow-Right.25f24a36b4aab6ad7a7afe943e9332f4.svg";
export { ForwardRef as ReactComponent };